export default __webpack_public_path__ + "static/media/rekava-logo-grey.6264fd98.svg";